import { StagesContext } from '@context/stagesContext'
import { useContext } from 'react'

export const useStages = () => {
  return useContext(StagesContext)
}
